import { handleActions } from 'redux-actions';
import * as filtersActions from '../actions/filters';

let initState = {
  count: 0,
  fields: null,
  search: null,
  typeList: null,
};

export const filters = handleActions(
  {
    [filtersActions.updateFilterFieldsExecutors]: (state, action) => {
      return {
        ...state,
        fields: action.payload,
      };
    },
    [filtersActions.searchExecutors]: (state, action) => {
      return {
        ...state,
        search: action.payload,
      };
    },
    [filtersActions.changeTypeListExecutors]: (state, action) => {
      return {
        ...state,
        typeList: action.payload,
      };
    },
    [filtersActions.countFiltersExecutors]: (state, action) => {
      return {
        ...state,
        count: action.payload,
      };
    },
    [filtersActions.resetFiltersExecutors]: (state, action) => {
      return {
        ...state,
        fields: null,
        search: null,
        count: 0,
      };
    },
  },
  initState
);
